export const GET_AU_COUNT_REQUEST="GET_AU_COUNT_REQUEST";
export const GET_AU_COUNT_SUCESS="GET_AU_COUNT_SUCESS";

export const FETCH_NOTIFICATION_DATA_REQUEST="FETCH_NOTIFICATION_DATA_REQUEST";
export const FETCH_NOTIFICATION_DATA_SUCCESS="FETCH_NOTIFICATION_DATA_SUCCESS";

export const FETCH_NOTIFICATION_LATEST_UPDATE_DATA_REQUEST="FETCH_NOTIFICATION_LATEST_UPDATE_DATA_REQUEST";
export const FETCH_NOTIFICATION_PANEL_SETTING_DATA_REQUEST="FETCH_NOTIFICATION_PANEL_SETTING_DATA_REQUEST";
export const RESET_NOTIFICATION_DATA_SUCCESS="RESET_NOTIFICATION_DATA_SUCCESS";
export const FETCH_FILTER_NOTIFICATION_DATA_REQUEST="FETCH_FILTER_NOTIFICATION_DATA_REQUEST";

export const UPDATE_NOTIFICATION_DATA_REQUEST="UPDATE_NOTIFICATION_DATA_REQUEST";
export const UPDATE_NOTIFICATION_DATA_SUCCESS="UPDATE_NOTIFICATION_DATA_SUCCESS";

export const UPDATE_NOTIFICATION_PANEL_SETTING_DATA_REQUEST="UPDATE_NOTIFICATION_PANEL_SETTING_DATA_REQUEST";
export const UPDATE_NOTIFICATION_PANEL_SETTING_DATA_SUCCESS="UPDATE_NOTIFICATION_PANEL_SETTING_DATA_SUCCESS";

export const CHANGE_GROUP_UPDATES_REQUEST="CHANGE_GROUP_UPDATES_REQUEST";
export const CHANGE_GROUP_UPDATES_SUCCESS="CHANGE_GROUP_UPDATES_SUCCESS";

export const RESET_WORKKARD_GROUP_COUNTER_REQUEST="RESET_WORKKARD_GROUP_COUNTER_REQUEST";
export const RESET_WORKKARD_GROUP_SUCCESS="RESET_WORKKARD_GROUP_SUCCESS";
export const FETCH_FILTER_GROUP_BY_DATA_REQUEST="FETCH_FILTER_GROUP_BY_DATA_REQUEST";

export const CHANGE_ACTIVITY_UPDATES_REQUEST="CHANGE_ACTIVITY_UPDATES_REQUEST";
export const CHANGE_ACTIVITY_UPDATES_SUCCESS="CHANGE_ACTIVITY_UPDATES_SUCCESS";

export const FETCH_NOTIFICATION_DETAIL_DATA_REQUEST="FETCH_NOTIFICATION_DETAIL_DATA_REQUEST";
export const FETCH_NOTIFICATION_DETAIL_DATA_SUCCESS="FETCH_NOTIFICATION_DETAIL_DATA_SUCCESS";

export const GET_WORKKARD_AU_STATUS_REQUEST="GET_WORKKARD_AU_STATUS_REQUEST";

export const RESET_NOTIFICATION_DETAIL="RESET_NOTIFICATION_DETAIL";
export const RESET_GROUPING_DATA="RESET_GROUPING_DATA";

export const MARK_ALL_READ="MARK_ALL_READ";
export const MARK_ALL_GROUP_READ="MARK_ALL_GROUP_READ";
export const UPDATE_NOTIFICATION_DETAIL_DATA_SUCCESS="UPDATE_NOTIFICATION_DETAIL_DATA_SUCCESS";

export const HIDE_HEADER_LOADER = 'HIDE_HEADER_LOADER';
export const SHOW_HEADER_LOADER = 'SHOW_HEADER_LOADER';
export const UPDATE_NOTIFICATION_COUNTER = 'UPDATE_NOTIFICATION_COUNTER';
export const NEW_NOTIFICATION_REQUEST = 'NEW_NOTIFICATION_REQUEST';
export const UPDATE_NEW_NOTIFICATION_DETAIL_DATA = 'UPDATE_NEW_NOTIFICATION_DETAIL_DATA';
export const RESET_NOTIFICATION_REQUEST="RESET_NOTIFICATION_REQUEST";
export const NOTIFICATION_SORTING_REQUEST="NOTIFICATION_SORTING_REQUEST";

export const UPDATE_RECENT_NOTIFICATION_STATUS_REQUEST ="UPDATE_RECENT_NOTIFICATION_STATUS_REQUEST";